import { useGlobalStacks } from "@/state/globalStacks";
import { useStacksRecenter } from "@/state/stacksRecenter";
import StacksWidget from "./Stacks";
import { SidebarGroup, SidebarGroupContent } from "../sidebar";

export default function StacksVertical() {
  const globalStacks = useGlobalStacks();
  // Bumped from the header's QuickIntervals, which no longer sits in this
  // subtree — see `src/state/stacksRecenter.ts`.
  const recenterToken = useStacksRecenter();

  return (
    <SidebarGroup className="h-full flex flex-column">
      {/* The level switcher moved into StacksHeader, which owns it alongside
          the From/To chips: it now re-levels the focused endpoint rather than
          the selection as a whole. The quick-range presets moved further out
          still, into the app header beside the interval they change. The widget
          scrolls itself, so no wrapper overflow here. */}
      <SidebarGroupContent className="grow min-h-0">
        <StacksWidget stacks={globalStacks} recenterToken={recenterToken} />
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
